import React from 'react'
import { useFt } from 'hooks'
import { constants } from 'helpers'

import { useDynamicNavigationBanner } from 'modules/banners'

import { Bone } from 'components/layout'
import { Href } from 'components/navigation'
import { BackgroundImage } from 'components/dataDisplay'

import { QuizBanner, BrandsBanner, GiftSubscriptionBanner } from 'compositions/Header/view/Desktop/components/banners'


type DynamicNavigationBannerProps = {
  placement: 'perfumes' | 'colognes' | 'discover' | 'search' | 'gifts'
  onClick?: () => void
}

const DynamicNavigationBanner: React.FunctionComponent<DynamicNavigationBannerProps> = (props) => {
  const { placement, onClick } = props

  const isStrapiBannersEnabled = useFt(constants.features.strapiBanners)
  const { isFetching, bannerData, handleClick } = useDynamicNavigationBanner({ placement, onClick, skip: !isStrapiBannersEnabled })

  if (isFetching) {
    return (
      <Bone className="bg-gray-70" h={296} />
    )
  }

  if (!isStrapiBannersEnabled || !bannerData) {
    if (placement === 'perfumes' || placement === 'colognes') {
      return (
        <BrandsBanner placement={placement} onClick={onClick} />
      )
    }

    if (placement === 'discover') {
      return (
        <QuizBanner onClick={onClick} />)
    }

    if (placement === 'gifts') {
      return (
        <GiftSubscriptionBanner onClick={onClick} />
      )
    }

    return null
  }

  const href = bannerData?.isExternalLink ? bannerData?.to : null

  return (
    <Href to={bannerData?.to} href={href} onClick={handleClick} data-testid="brandsBanner">
      <BackgroundImage
        className="flex flex-col items-start justify-center bg-gray-70 p-32"
        src={bannerData?.bgImage}
        style={{ backgroundPosition: '0 50%', height: '296rem' }}
      />
    </Href>
  )
}


export default DynamicNavigationBanner
